import { Box, Button, Card, CardContent, Typography } from '@mui/material';
import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { Event } from '../types/search.types';
import { stripHtml } from '../utils/stripHtml';

interface SearchEventCardProps extends RouteComponentProps {
  event: Event;
}

const SearchEventCardComponent: React.FC<SearchEventCardProps> = ({
  event,
  history,
}) => {
  const handleVisualize = () => {
    history.push(`/viewer/${event.eventUId}/${event.useCaseId}`);
  };

  return (
    <Card
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        borderRadius: '8px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        transition: 'transform 0.2s, box-shadow 0.2s',
        '&:hover': {
          transform: 'translateY(-2px)',
          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
        },
      }}
    >
      <CardContent
        sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          pl: 3.5,
          pr: 3.5,
          mb: 1,
          mt: 1,
        }}
      >
        <Typography
          variant="h6"
          sx={{
            fontFamily: 'Roboto-Bold',
            mb: 1,
            color: '#667eea',
            textAlign: 'center',
          }}
        >
          {stripHtml(event.title)}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            mb: 1,
            color: '#666',
            flexGrow: 1,
            textAlign: 'justify',
          }}
        >
          {stripHtml(event.description)}
        </Typography>
        <Box sx={{ display: 'flex', gap: 2, mb: 1, justifyContent: 'center' }}>
          <Typography variant="body2" sx={{ color: '#888' }}>
            <b>INÍCIO:</b>{' '}
            {new Date(event.startDate).toLocaleDateString('pt-BR', {
              day: '2-digit',
              month: '2-digit',
              year: 'numeric',
            })}{' '}
            | <b>FIM:</b>{' '}
            {new Date(event.endDate).toLocaleDateString('pt-BR', {
              day: '2-digit',
              month: '2-digit',
              year: 'numeric',
            })}
          </Typography>
        </Box>

        <Button
          variant="contained"
          onClick={handleVisualize}
          fullWidth
          sx={{
            mt: 1,
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            color: '#fff',
            textTransform: 'none',
            fontFamily: 'Roboto-Bold',
            '&:hover': {
              background: 'linear-gradient(135deg, #5568d3 0%, #653a8b 100%)',
            },
          }}
        >
          VISUALIZAR
        </Button>
      </CardContent>
    </Card>
  );
};

export const SearchEventCard = withRouter(SearchEventCardComponent);
